import {
  Box,
  Icon,
  Input,
  PlacementWithLogical,
  Text,
  Tooltip,
  VStack,
} from "@chakra-ui/react";
import Linkify from "linkify-react";
import { FaTimesCircle } from "react-icons/fa";
import useAuthContext from "~/context/auth.context";
import { linkifyOptions } from "~/core/helpers";
import { ProjectDocument } from "~/core/types";

export default function CustomFieldRequirement({
  project,
  isTooltipOpen,
  tooltipPosition,
  customFieldValue,
  setCustomFieldValue,
}: {
  project: ProjectDocument;
  isTooltipOpen: boolean;
  tooltipPosition?: PlacementWithLogical;
  customFieldValue: string;
  setCustomFieldValue: (value: string) => void;
}) {
  const { user } = useAuthContext();

  return project?.customfield?.enabled &&
    project?.customfield?.labels &&
    project?.customfield?.labels[0] ? (
    <Tooltip
      label={
        <>
          Required field is not filled. <br />
          <strong>{project?.customfield?.labels[0]}</strong>
        </>
      }
      isOpen={isTooltipOpen}
      padding={4}
      fontSize={"md"}
      backgroundColor={"red.500"}
      placement={tooltipPosition}
      hasArrow
    >
      <Box
        px={8}
        py={4}
        w={"100%"}
        backgroundColor={"transparent"}
        display="flex"
        flexDirection="row"
        alignItems="start"
        borderBottom={"1px"}
        borderColor={"boxBorder"}
        style={{ marginTop: "0" }}
      >
        <VStack alignItems={"start"} w={"100%"}>
          <Text fontSize="18" fontWeight="500" color={"descText"}>
            Open Response{" "}
            {isTooltipOpen && (
              <Icon ml="2" as={FaTimesCircle} color="#CD4A38" />
            )}
          </Text>

          <Text fontSize="13" color={"descText"}>
            <Linkify options={linkifyOptions}>
              {project?.customfield?.labels[0]}
            </Linkify>
          </Text>

          <Input
            value={customFieldValue}
            w={"100%"}
            disabled={!user}
            onChange={(e) => {
              setCustomFieldValue(e.target.value);
            }}
            borderColor={"gray.500"}
            placeholder={project?.customfield?.labels[0]}
          />
        </VStack>
      </Box>
    </Tooltip>
  ) : null;
}
